export const calendarStyles = `
  /* ── CSS Variables ── */
  .fc {
    --fc-border-color: rgb(228 228 231); /* zinc-200 */
    --fc-today-bg-color: rgba(27, 77, 46, 0.06);
    --fc-page-bg-color: transparent;
    --fc-neutral-bg-color: transparent;
    --fc-list-event-hover-bg-color: rgba(27, 77, 46, 0.06);
    --fc-event-border-color: transparent;
    font-family: inherit;
  }

  .dark .fc {
    --fc-border-color: rgb(63 63 70 / 0.6); /* zinc-700/60 */
    --fc-today-bg-color: rgba(27, 77, 46, 0.10);
    --fc-page-bg-color: transparent;
    --fc-neutral-bg-color: transparent;
  }

  /* ── Day Headers ── */
  .fc .fc-col-header-cell {
    padding: 0.625rem 0;
    border-bottom: 1px solid var(--fc-border-color);
    background: transparent;
  }

  .fc .fc-col-header-cell-cushion {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgb(113 113 122); /* zinc-500 */
    text-decoration: none;
    padding: 0;
  }

  .dark .fc .fc-col-header-cell-cushion {
    color: rgb(161 161 170); /* zinc-400 */
  }

  /* ── Day Numbers ── */
  .fc .fc-daygrid-day-number {
    font-size: 0.8125rem;
    font-weight: 500;
    color: rgb(63 63 70); /* zinc-700 */
    padding: 0.375rem 0.5rem;
    text-decoration: none;
  }

  .dark .fc .fc-daygrid-day-number {
    color: rgb(212 212 216); /* zinc-300 */
  }

  /* ── Today Highlight ── */
  .fc .fc-day-today .fc-daygrid-day-number {
    background-color: #1b4d2e;
    color: #ffffff;
    border-radius: 9999px;
    width: 1.625rem;
    height: 1.625rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0.25rem;
    font-weight: 600;
  }

  /* ── Grid Borders ── */
  .fc .fc-scrollgrid {
    border: none !important;
  }

  .fc .fc-scrollgrid td,
  .fc .fc-scrollgrid th {
    border-color: var(--fc-border-color);
  }

  /* Remove outer borders so card wrapper handles them */
  .fc .fc-scrollgrid-section > td {
    border-right: none;
    border-bottom: none;
  }

  .fc .fc-scrollgrid-section > th {
    border-right: none;
  }

  .fc .fc-daygrid-day {
    transition: background-color 150ms ease;
  }

  .fc .fc-daygrid-day:hover {
    background-color: rgba(27, 77, 46, 0.03);
  }

  .dark .fc .fc-daygrid-day:hover {
    background-color: rgba(27, 77, 46, 0.06);
  }

  /* ── Other-month days ── */
  .fc .fc-day-other .fc-daygrid-day-number {
    opacity: 0.35;
  }

  /* ── Event Chips ── */
  .fc .fc-event {
    border-radius: 0.375rem;
    border: none !important;
    padding: 0.125rem 0.375rem;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.125rem;
    transition: box-shadow 150ms ease, transform 150ms ease;
    cursor: pointer;
  }

  .fc .fc-event:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
  }

  .dark .fc .fc-event:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .fc .fc-daygrid-event {
    margin: 1px 2px;
  }

  .fc .fc-daygrid-block-event .fc-event-time,
  .fc .fc-daygrid-block-event .fc-event-title {
    padding: 0 0.125rem;
  }

  /* ── "+N more" Link ── */
  .fc .fc-daygrid-more-link {
    font-size: 0.6875rem;
    font-weight: 600;
    color: rgb(113 113 122); /* zinc-500 */
    background: rgb(244 244 245); /* zinc-100 */
    border-radius: 9999px;
    padding: 0.125rem 0.5rem;
    margin: 2px 2px 0;
    text-decoration: none;
    transition: background-color 150ms ease;
  }

  .fc .fc-daygrid-more-link:hover {
    background: rgb(228 228 231); /* zinc-200 */
    color: rgb(63 63 70);
  }

  .dark .fc .fc-daygrid-more-link {
    background: rgb(63 63 70 / 0.5);
    color: rgb(161 161 170);
  }

  .dark .fc .fc-daygrid-more-link:hover {
    background: rgb(63 63 70);
    color: rgb(212 212 216);
  }

  /* ── Week View ── */
  .fc .fc-timegrid-slot-label-cushion {
    font-size: 0.6875rem;
    color: rgb(161 161 170); /* zinc-400 */
    font-weight: 500;
    padding-right: 0.5rem;
  }

  .dark .fc .fc-timegrid-slot-label-cushion {
    color: rgb(113 113 122); /* zinc-500 */
  }

  .fc .fc-timegrid-slot {
    height: 2.5rem;
    border-color: var(--fc-border-color);
  }

  .fc .fc-timegrid-slot-minor {
    border-top-style: dotted;
  }

  /* Now indicator */
  .fc .fc-timegrid-now-indicator-line {
    border-color: #1b4d2e;
    border-width: 2px 0 0 0;
  }

  .fc .fc-timegrid-now-indicator-arrow {
    border-color: #1b4d2e;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }

  /* Week view events */
  .fc .fc-timegrid-event {
    border-radius: 0.375rem;
    border: none !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .fc .fc-timegrid-event .fc-event-main {
    padding: 0.25rem 0.375rem;
    font-size: 0.75rem;
  }

  /* ── Dark Mode: Grid & Cells ── */
  .dark .fc .fc-daygrid-day-bg .fc-bg-event {
    opacity: 0.08;
  }

  .dark .fc .fc-col-header-cell {
    border-color: var(--fc-border-color);
  }

  .dark .fc .fc-daygrid-day-frame {
    background: transparent;
  }

  .dark .fc .fc-scrollgrid td,
  .dark .fc .fc-scrollgrid th {
    border-color: var(--fc-border-color);
  }

  /* ── Popover ("+N more" popup) ── */
  .fc .fc-popover {
    border-radius: 0.75rem;
    border: 1px solid rgb(228 228 231);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .fc .fc-popover-header {
    background: rgb(250 250 250);
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgb(113 113 122);
  }

  .fc .fc-popover-body {
    padding: 0.25rem;
  }

  .dark .fc .fc-popover {
    background: rgb(39 39 42);
    border-color: rgb(63 63 70 / 0.6);
  }

  .dark .fc .fc-popover-header {
    background: rgb(39 39 42);
    color: rgb(161 161 170);
  }

  /* ── Mobile Optimizations ── */
  @media (max-width: 640px) {
    .fc {
      font-size: 0.8125rem !important;
    }

    .fc .fc-col-header-cell-cushion {
      font-size: 0.625rem;
    }

    .fc .fc-daygrid-day {
      min-height: 70px !important;
    }

    .fc .fc-daygrid-day-number {
      padding: 0.1875rem 0.25rem !important;
      font-size: 0.75rem !important;
    }

    .fc .fc-day-today .fc-daygrid-day-number {
      width: 1.375rem;
      height: 1.375rem;
      font-size: 0.6875rem !important;
    }

    .fc .fc-event {
      padding: 0.0625rem 0.1875rem !important;
      font-size: 0.6875rem !important;
      line-height: 0.875rem !important;
    }

    .fc .fc-daygrid-more-link {
      font-size: 0.625rem !important;
      padding: 0.0625rem 0.375rem;
    }

    .fc .fc-daygrid-day-events {
      margin: 0 !important;
    }

    .fc .fc-daygrid-event {
      margin: 1px 0 !important;
    }

    .fc .fc-daygrid-block-event .fc-event-time,
    .fc .fc-daygrid-block-event .fc-event-title {
      padding: 0 !important;
    }
  }

  /* ── Datetime-local Input Styles ── */
  input[type="datetime-local"] {
    appearance: none;
    background-color: transparent;
    border: 1px solid rgb(24 24 27 / 0.1);
    border-radius: 0.5rem;
    color: rgb(24 24 27);
    font-size: 0.875rem;
    line-height: 1.5rem;
    padding: 0.5rem 0.75rem;
    width: 100%;
    transition: all 150ms ease-in-out;
  }

  input[type="datetime-local"]:hover {
    border-color: rgb(24 24 27 / 0.2);
  }

  input[type="datetime-local"]:focus {
    border-color: rgb(24 24 27 / 0.3);
    outline: none;
    box-shadow: 0 0 0 2px rgb(24 24 27 / 0.1);
  }

  .dark input[type="datetime-local"] {
    border-color: rgb(255 255 255 / 0.1);
    color: rgb(255 255 255);
    background-color: rgb(255 255 255 / 0.05);
  }

  .dark input[type="datetime-local"]:hover {
    border-color: rgb(255 255 255 / 0.2);
  }

  .dark input[type="datetime-local"]:focus {
    border-color: rgb(255 255 255 / 0.3);
    box-shadow: 0 0 0 2px rgb(255 255 255 / 0.1);
  }

  input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    background: transparent;
    cursor: pointer;
    padding: 0;
    margin: 0;
    opacity: 0.5;
    transition: opacity 150ms ease-in-out;
  }

  input[type="datetime-local"]::-webkit-calendar-picker-indicator:hover {
    opacity: 0.8;
  }

  .dark input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
`;
